import React from 'react';

import { Fabric } from 'office-ui-fabric-react/lib/Fabric';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';

import StepZilla from 'react-stepzilla';
import Cookies from "universal-cookie";
import XHRUploader from 'react-xhr-uploader';

import Header from '../component/Header';
import HttpService from '../service/HttpService';

class PolicySelection extends React.Component {
  render() {
    return (
      <div className="ms-Grid">
        <div className="ms-Grid-rows"> 
          <div className="ms-Grid-col ms-sm12">
          <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm12 ms-lg6">
                <Dropdown
                    placeHolder="Seleccione un cliente"
                    label="Cliente"
                    name="client"
                    options={ this.props.clients }
                    onChanged={ this.props.onClientSelected } />
              </div>
            </div>
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm12 ms-lg6">
                <Dropdown
                    placeHolder="Seleccione una póliza"
                    label="Póliza"
                    name="policy"
                    options={ this.props.policies }
                    onChanged={ this.props.onPolicySelected } />
              </div>
            </div>
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm12 ms-lg6" style={{ textAlign: 'right' }}>
                { this.props.selectedPolicy && 
                <PrimaryButton onClick={ () => { this.props.jumpToStep(1) } } style={{ marginTop: 20 }}>Continuar</PrimaryButton>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class PolicyData extends React.Component {
  http = new HttpService();

  renew = ( values ) => {
    this.http.savePolicy( values )
      .then( values => {
        this.props.jumpToStep( 2 );
      })
      .catch( console.error );
  }

  render() {
    const _client = this.props.selectedClient;

    var data = {
      id: this.props.selectedPolicy.id,
      policy_number: null,
      coverage_start: null,
      coverage_end: null
    };

    return (
      <div className="ms-Grid">
        <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12 ms-lg6">
            <h3 className="ms-font-xl">{ this.props.selectedPolicy.policy_number } ({ this.props.selectedPolicy.company_name })</h3>
            <hr />
            <p><strong className="ms-fontWeight-semibold">Compañia</strong>: { this.props.selectedPolicy.company_name }</p>
            <p><strong className="ms-fontWeight-semibold">Tipo</strong>: { this.props.selectedPolicy.type_name }</p>
            <p><strong className="ms-fontWeight-semibold">Póliza</strong>: { this.props.selectedPolicy.policy_number }</p>
            <p><strong className="ms-fontWeight-semibold">Inicio cobertura</strong>: { this.props.selectedPolicy.coverage_start }</p>
            <p><strong className="ms-fontWeight-semibold">Fin cobertura</strong>: { this.props.selectedPolicy.coverage_end }</p>
            <p>
              <strong>Cliente</strong><br/>
              { this.props.selectedPolicy.client_name }<br/>
              { _client.documentNumber }<br/>
              { _client.addressStreet } { _client.addressNumber }<br />
              { _client.addressZipcode } { _client.addressCity } { _client.addressState }<br/><br/>
              <em>Teléfono</em> { _client.phone }<br/>
              <em>Email</em> { _client.email }<br/>
            </p>
          </div>
          <div className="ms-Grid-col ms-sm12 ms-lg6">
            <h3 className="ms-font-xl">{ this.props.selectedPolicy.policy_number } ({ this.props.selectedPolicy.company_name })</h3>
            <hr />
            <p><strong className="ms-fontWeight-semibold">Compañia</strong>: { this.props.selectedPolicy.company_name }</p>
            <p><strong className="ms-fontWeight-semibold">Tipo</strong>: { this.props.selectedPolicy.type_name }</p>
            <div><strong className="ms-fontWeight-semibold">Póliza</strong>: <TextField label="Número de póliza" onChange={ ( item ) => { data.policy_number = item.target.value } }/></div>
            <div><strong className="ms-fontWeight-semibold">Póliza</strong>: <TextField label="Inicio cobertura" onChange={ ( item ) => { data.coverage_start = item.target.value } }/></div>
            <div><strong className="ms-fontWeight-semibold">Póliza</strong>: <TextField label="Fin cobertura" onChange={ ( item ) => { data.coverage_end = item.target.value } }/></div>
          </div>
        </div>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12 ms-lg12" style={{ textAlign: 'right'}}>
            <PrimaryButton onClick={ () => { 
              this.renew( data );  
            }} style={{ marginTop: 20 }}>Renovar</PrimaryButton>
          </div>
        </div>
      </div>
    );
  }
}

class PolicyEnd extends React.Component {
  render() {
    return(
      <div className="ms-Grid">
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12 ms-lg6">
            <h3>Póliza renovada!</h3>
            <p>Ahora sólo falta adjuntar la documentación.
            <XHRUploader url={ "https://gosalbezehijos.com/entrypoint/insurance/attachments?policy=" + this.props.policy } dropzoneLabel='Arrastre o seleccione el archivo que se desea adjuntar' auto />
            </p>
          </div>
        </div>
      </div>
    )
  }
}

export default class PolicyRenew extends React.Component {
  http = new HttpService();
  loader = null;

  constructor( props ) {
    super( props );

    let cookies = new Cookies();
    let session = cookies.get( 'session' );

    this.state = {
      clients: [],
      policies: [],
      policyID: null,
      selectedPolicy: null,
      selectedClient: null
    }

    if( !session ) {
      window.location.href = '/auth';
    }
  }

  componentDidMount() {
    let loader = this.refs.header.loader();

    loader.loading( 'Cargando clientes...' );

    this.http
      .getClients()
      .then( clients => {
        this.setState({ clients: clients });
        loader.finish();
      })
      .catch( console.error );
  }

  clientSelectedHandler = ( item ) => {
    this.http
      .getPolicies()
      .then( policies => {
        let pol = [];

        policies.forEach( policy => {
          if ( policy.client == item.id ) {
            pol.push( policy );
          }
        });

        this.setState({
          policies: pol,
          selectedClient: item
        });
      })
      .catch( console.error );
  }

  policySelectedHandler = ( item ) => {
    this.setState({
      selectedPolicy: item,
      policyID: item.id
    });
  }
  
  render() {
    const steps = [
      { 
        name:"Seleccionar póliza", 
        component: <PolicySelection 
          clients={this.state.clients} 
          policies={ this.state.policies } 
          onClientSelected={ this.clientSelectedHandler }
          onPolicySelected={ this.policySelectedHandler }
          selectedPolicy={ this.state.selectedPolicy }
        /> 
      }, { 
        name:"Datos de la póliza", 
        component: <PolicyData 
          selectedPolicy={ this.state.selectedPolicy }
          selectedClient={ this.state.selectedClient }
        /> 
      }, {
        name:"Documentación",
        component: <PolicyEnd policy={ this.state.policyID } />
      }
    ];

    return ( 
      <Fabric>
        <Header title="Renovar póliza" ref="header" />
        <div className="ms-Grid">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-lg1"></div>
            <div className="ms-Grid-col ms-sm-12 ms-lg10">
              <div className='step-progress'>
                <StepZilla steps={ steps } stepsNavigation={false} showNavigation={false}/>
              </div>
            </div>
          </div>
        </div>
      </Fabric>
    )
  }
}


// WEBPACK FOOTER //
// ./src/screen/PolicyRenew.jsx